import { ColumnSortType, TableColumnTypes } from '../../model/table.model';

export const tableHeaders = [
  {
    value: 'phone_number',
    sort: ColumnSortType.NONE,
    name: 'phone',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'tg_id',
    sort: ColumnSortType.NONE,
    name: 'approved',
    type: TableColumnTypes.BOOLEAN,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        { icon: 'delete', label: 'delete', value: 'DELETE' },
      ],
    translate: true,
  },
];
